export const GET_STAFF='GET_STAFF';
export const ADD_STAFF='ADD_STAFF';
export const DELETE_STAFF='DELETE_STAFF';
export const START_LOADING_STAFF='START_LOADING_STAFF';
export const END_LOADING_STAFF='END_LOADING_STAFF';
